import type { AdminUserDetail } from 'src/types/admin/user-detail';

import { useContext, createContext } from 'react';

type AdminUserDetailContextType = {
  user: AdminUserDetail;
  mainGroupId: number;
  refresh: () => void;
  canEditYearlyCreditRenewal: boolean;
};

export const AdminUserDetailContext = createContext<AdminUserDetailContextType | null>(null);

export function useAdminUserDetail(): AdminUserDetailContextType {
  const context = useContext(AdminUserDetailContext);
  if (!context) {
    throw new Error('useAdminUserDetail must be used within AdminUserDetailLayout');
  }
  return context;
}
